import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=f4b4f73c&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=f4b4f73c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4b4f73c"

export default script